import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPieChart = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M11.25 1.527C9.30596 1.66631 7.43906 2.34397 5.8583 3.48409C4.27754 4.62422 3.04531 6.18183 2.29956 7.98253C1.5538 9.78324 1.32396 11.756 1.63576 13.6799C1.94756 15.6038 2.78869 17.403 4.065 18.876L11.25 11.6895V1.527ZM12.75 1.527V11.25H22.473C22.2923 8.73107 21.2098 6.36162 19.4241 4.57589C17.6384 2.79016 15.2689 1.70774 12.75 1.527V1.527ZM22.473 12.75H12.3105L5.1255 19.935C6.59853 21.2109 8.39757 22.0516 10.3213 22.3632C12.245 22.6748 14.2174 22.4448 16.0178 21.6991C17.8183 20.9534 19.3757 19.7213 20.5157 18.1408C21.6558 16.5603 22.3335 14.6938 22.473 12.75V12.75ZM0 12C0 8.8174 1.26428 5.76516 3.51472 3.51472C5.76516 1.26428 8.8174 0 12 0C15.1826 0 18.2348 1.26428 20.4853 3.51472C22.7357 5.76516 24 8.8174 24 12C24 15.1826 22.7357 18.2348 20.4853 20.4853C18.2348 22.7357 15.1826 24 12 24C8.8174 24 5.76516 22.7357 3.51472 20.4853C1.26428 18.2348 0 15.1826 0 12V12Z",
		fill: "var(--colors-grey-1)"
	})
});
export default SvgPieChart;
